import { EGDSSpacing } from '@egds/react-core/spacing';
import * as React from 'react';
import { ErrorBoundary } from 'bernie-view';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { PropertyWhatsAround, PropertyWhatsAroundSplitted } from '@shared-ui/lodging-property-details';
import { RefTarget } from '@shared-ui/ref-context';
import { withSharedUiPropertyDetails } from './shared-ui-property-details';
import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';
import { usePropertyDetailsQueryCSRExperiment } from './use-property-details-query';
const WhatsAroundWrapper = ({
  inputs
}) => {
  const cSRPropertyDetailsQuery = usePropertyDetailsQueryCSRExperiment();
  return React.createElement(Experiment, {
    name: "Dated_PDP_Split_ProductDetailsQuery"
  }, React.createElement(ExperimentControl, null, React.createElement(ErrorBoundary, {
    label: "hotel.information.whats-around.map"
  }, React.createElement(EGDSSpacing, {
    margin: {
      block: 'six'
    }
  }, React.createElement(RefTarget, {
    name: "Location",
    dataStid: "whats-around"
  }, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(PropertyWhatsAround, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  })))))), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(ErrorBoundary, {
    label: "hotel.information.whats-around.map"
  }, React.createElement(EGDSSpacing, {
    margin: {
      block: 'six'
    }
  }, React.createElement(RefTarget, {
    name: "Location",
    dataStid: "whats-around"
  }, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(PropertyWhatsAroundSplitted, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  })))))));
};
// @ts-ignore
export const SharedUiWhatsAroundWrapper = withSharedUiPropertyDetails(WhatsAroundWrapper);
SharedUiWhatsAroundWrapper.displayName = 'SharedUiWhatsAroundWrapper';